import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=132d84c2&"
import script from "./Gauge.vue?vue&type=script&lang=ts&"
export * from "./Gauge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports